// extracted by mini-css-extract-plugin
module.exports = {"NewGameTypesBlock":"NewGameType_NewGameTypesBlock__MKHMR"};